<template>
  <div class="qcrb-applyAdmin">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <el-form
            ref="formMaster"
            :model="formMaster"
            label-width="160px">
            <el-col :span="24">
              <div class="basic-title"><em>文书管理</em></div>
            </el-col>
            <div class="basic-padding2">
              <el-col :span="6">
                <template v-if="typeof formProlist.crm_id !== 'undefined'">
                  <jm-upload-file
                    url="/newfib.php/index/apply_file/upload"
                    :upload-data="crmOfferId"
                    :show-file-list='true'
                    :upload-additional="{
                      upload_position: '教授列表',
                      upload_type_str: '教授列表',
                      offer_school_id: 0
                  }">
                    <template slot="uploadFile">
                      <el-button type="primary">上传教授列表</el-button>
                    </template>
                  </jm-upload-file>
                </template>
              </el-col>
              <el-col :span="6">
                <template v-if="typeof formProlist.crm_id !== 'undefined'">
                  <jm-upload-file
                    url="/newfib.php/index/apply_file/upload"
                    :upload-data="crmOfferId"
                    :show-file-list='true'
                    :upload-additional="{
                      upload_position: '邮箱交接说明书',
                      upload_type_str: '邮箱交接说明书',
                      offer_school_id: 0
                  }">
                    <template slot="uploadFile">
                      <el-button type="primary">邮箱交接说明书</el-button>
                    </template>
                  </jm-upload-file>
                </template>
              </el-col>
            </div>
            <!--            <el-col :span="8">-->
            <!--              <el-form-item label="教授列表是否发送：">-->
            <!--                <jm-dict-select-->
            <!--                  :class="sNum1 ? 'disabled-select' : ''"-->
            <!--                  class="send-select-check"-->
            <!--                  @change="(current) => timePush(current, 0)"-->
            <!--                  clearable-->
            <!--                  type="dataset"-->
            <!--                  dict-type="qcrb"-->
            <!--                  v-model="formProlist.baseinfo.is_prof_list"-->
            <!--                  name="handleYesNo"/>-->
            <!--                &emsp;<span v-model="formProlist.baseinfo.prof_list_date">{{ formProlist.baseinfo.prof_list_date }}</span>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <!--            <el-col :span="16">-->
            <!--              <el-form-item label="教授列表是否反馈：">-->
            <!--                <jm-dict-select-->
            <!--                  :class="sNum2 ? 'disabled-select' : ''"-->
            <!--                  @change="(current) => timePush(current, 1)"-->
            <!--                  clearable-->
            <!--                  type="dataset"-->
            <!--                  dict-type="qcrb"-->
            <!--                  v-model="formProlist.baseinfo.is_prof_feedback"-->
            <!--                  name="handleYesNo"/>-->
            <!--                &emsp;<span v-model="formProlist.baseinfo.prof_feedback_date">{{ formProlist.baseinfo.prof_feedback_date }}</span>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <!--            <el-col :span="8">-->
            <!--              <el-form-item label="自荐信是否完成：">-->
            <!--                <jm-dict-select-->
            <!--                  :class="sNum3 ? 'disabled-select' : ''"-->
            <!--                  @change="(current) => timePush(current, 2)"-->
            <!--                  clearable-->
            <!--                  type="dataset"-->
            <!--                  dict-type="qcrb"-->
            <!--                  v-model="formProlist.baseinfo.is_letter_complete"-->
            <!--                  name="handleYesNo"/>-->
            <!--                &emsp;<span v-model="formProlist.baseinfo.letter_complete_date">{{ formProlist.baseinfo.letter_complete_date }}</span>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <!--            <el-col :span="16">-->
            <!--              <el-form-item label="第一封邮件是否发送：">-->
            <!--                <jm-dict-select-->
            <!--                  :class="sNum4 ? 'disabled-select' : ''"-->
            <!--                  class="send-select-check"-->
            <!--                  @change="(current) => timePush(current, 3)"-->
            <!--                  clearable-->
            <!--                  type="dataset"-->
            <!--                  dict-type="qcrb"-->
            <!--                  v-model="formProlist.baseinfo.is_letter_send"-->
            <!--                  name="handleYesNo"/>-->
            <!--                &emsp;<span v-model="formProlist.baseinfo.letter_send_date">{{ formProlist.baseinfo.letter_send_date }}</span>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <el-col :span="24">
              <div class="mails-wrap">
                <el-row>
                  <el-col :span="5">
                    <span>申请邮箱：</span>
                  </el-col>
                  <el-col :span="5">
                    <span>邮箱密码：</span>
                  </el-col>
                  <el-col :span="5">
                    <span>备注信息：</span>
                  </el-col>
                </el-row>
                <p>&nbsp;</p>
                <div class="mails-line" v-for="(item, index) in formProlist.baseinfo.mail_list" :key="index">
                  <el-row>
                    <el-col :span="5">
                      <el-input
                        clearable
                        placeholder="申请邮箱"
                        class="jm-input220"
                        v-model="item.email"/>
                    </el-col>
                    <el-col :span="5">
                      <el-input
                        clearable
                        placeholder="邮箱密码"
                        class="jm-input220"
                        v-model="item.password"/>
                    </el-col>
                    <el-col :span="5">
                      <el-input
                        clearable
                        placeholder="备注信息"
                        class="jm-input220"
                        v-model="item.memo"/>
                    </el-col>
                    <el-col :span="6">
                      <i @click="addMailList" v-show="index === 0" class="el-icon-circle-plus mails-icon"></i>
                      <i @click="deleteMailList(index)" v-show="index !== 0" class="el-icon-remove mails-icon"></i>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
            <div class="clearfix"/>
            <div class="wrap-line">
              <el-col :span="8">
                <el-form-item label="申请学校：">
                  <jm-school-search
                    clearable
                    :country-id="485"
                    v-model="schoolObj"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="申请研究科：">
                  <jm-school-org-search
                    clearable
                    :school-id="schoolId"
                    v-model="orgObj"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-button
                  @click="addProcess"
                  type="primary">添加流程</el-button>
              </el-col>
            </div>
          </el-form>
          <div class="wrap-line"/>
          <div class="clearfix"/>
          <div
            v-if="formProlist.schoolList.length > 0"
            v-loading="loading"
            element-loading-text="拼命加载中"
            class="table-agile-info">
            <el-col :span="24">
              <div class="basic-padding2">
                <el-button
                  @click="sortClick"
                  type="primary"
                  size="small">按预计出愿时间排序</el-button>
              </div>
            </el-col>
            <div class="clearfix"/>
            <el-collapse v-model="activeNames" class="qcrb-apply-collapse">
              <el-collapse-item
                v-for="(item, index) in formProlist.schoolList"
                :key="item.id"
                :name="item.id">
                <a :id="`s_${item.id}`"/>
                <template slot="title">
                  <span>流程{{ index+1 }}：{{ item.sh_name }}&nbsp;-&nbsp;{{ item.org_name }}</span>
                  <div
                    @click.stop
                    class="jm-show title-select">
                    <jm-dict-select
                      size="mini"
                      type="dataset"
                      dict-type="qcrb"
                      v-model="item.stage"
                      name="applyStatus"/>
                  </div>
                  <div class="jm-show title-select">
                    <jm-dict-select
                      :show="true"
                      class="qcrb-apply-title"
                      size="mini"
                      type="dataset"
                      dict-type="qcrb"
                      v-model="item.status"
                      name="serviceStatus"/>
                  </div>
                  <span
                    @click.stop
                    class="title-right">预计出愿时间：
                    <el-date-picker
                      :editable="false"
                      :clearable="false"
                      size="mini"
                      type="date"
                      placeholder="选择日期"
                      v-model="item.expect_date"/>
                  </span>
                </template>
                <div v-if="showSchoolDetail(item.id)" style="padding: 15px;">
                  <el-form ref="formProcess" :model="formProcess">
                    <el-col :span="8">
                      <el-form-item label="确定办理时间：">
                        <el-date-picker
                          :editable="false"
                          :clearable="false"
                          class="jm-input220"
                          type="date"
                          placeholder="选择日期"
                          v-model="item.confirm_date"/>
                      </el-form-item>
                    </el-col>
                  <!--                    <el-col :span="8">-->
                  <!--                      <el-form-item label="入试信息：">-->
                  <!--                        <el-input-->
                  <!--                          class="jm-input220"-->
                  <!--                          v-model="item.exam_link"/>-->
                  <!--                      </el-form-item>-->
                  <!--                    </el-col>-->
                  <!--                    <el-col :span="8">-->
                  <!--                      <el-form-item label="出愿要项链接：">-->
                  <!--                        <el-input-->
                  <!--                          class="jm-input220"-->
                  <!--                          v-model="item.memo_link"/>-->
                  <!--                      </el-form-item>-->
                  <!--                    </el-col>-->
                  <!--                    <div class="jm-cb"/>-->
                  <!--                    <el-form-item label="申请方式：">-->
                  <!--                      <el-checkbox-group v-model="item.apply_type">-->
                  <!--                        <el-checkbox-->
                  <!--                          v-for="item in cbApplyData"-->
                  <!--                          :label="item.value"-->
                  <!--                          :key="item.value">{{ item.label }}</el-checkbox>-->
                  <!--                      </el-checkbox-group>-->
                  <!--                    </el-form-item>-->
                  <!--                    <el-col :span="8">-->
                  <!--                      <el-form-item label="同时出院生：">-->
                  <!--                        <jm-dict-select-->
                  <!--                          clearable-->
                  <!--                          class="jm-input220"-->
                  <!--                          type="dataset"-->
                  <!--                          dict-type="qcrb"-->
                  <!--                          v-model="item.same_as_leaving"-->
                  <!--                          name="handleYesNo"/>-->
                  <!--                      </el-form-item>-->
                  <!--                    </el-col>-->
                  <!--                    <div class="clearfix"/>-->
                  <!--                    <el-form-item-->
                  <!--                      v-if="item.same_as_leaving === 1"-->
                  <!--                      label="考试方式：">-->
                  <!--                      <el-checkbox-group v-model="item.exam_type">-->
                  <!--                        <el-checkbox-->
                  <!--                          v-for="item in cbApplyData2"-->
                  <!--                          :label="item.value"-->
                  <!--                          :key="item.value">{{ item.label }}</el-checkbox>-->
                  <!--                      </el-checkbox-group>-->
                  <!--                    </el-form-item>-->
                  </el-form>
                  <div class="clearfix"/>
                  <el-tabs
                    v-model="editableTabsValue[index]"
                    type="card"
                    editable
                    @tab-add="tabadd(index)"
                    @tab-remove="(current) => tabremove(current, index)">
                    <el-tab-pane
                      v-for="(subItem, sIndex) in item.professorList"
                      :key="sIndex"
                      :label="subItem.prof_name2"
                      :name="subItem.prof_name2">
                      <el-form
                        ref="formTeach"
                        :model="formTeach"
                        label-width="140px">
                        <el-col :span="8">
                          <el-form-item label="意向教授：">
                            <el-input class="jm-input220" v-model="subItem.prof_name"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="是否有面试：">
                            <jm-dict-select
                              clearable
                              type="dataset"
                              dict-type="qcrb"
                              v-model="subItem.is_meet"
                              name="handleYesNo"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label="面试结果：">
                            <jm-dict-select
                              clearable
                              type="dataset"
                              dict-type="qcrb"
                              v-model="subItem.status"
                              name="handleState"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="16">
                          <el-form-item label="研究计划书题目：">
                            <el-input class="jm-input220" v-model="subItem.plan_book_name"/>
                            <!-- :file-list="formProlist.schoolList[index].professorList[sIndex].plan_book_file" -->
                            <jm-upload
                              class="upload-button"
                              action='/newfib.php/index/qc_process/uploadFile'
                              :file-list="subItem.plan_book_file"
                              :on-preview="planPreview"
                              :on-success="(response, file, fileList) => planUploadSuccess(response, file, fileList, index, sIndex)"
                              :on-remove="(file, fileList) => planUploadRemove(file, fileList, index, sIndex)"
                              :show-file-list="true">
                              <el-button size="small" type="primary">上传研究计划书</el-button>
                            </jm-upload>
                          </el-form-item>
                        </el-col>
                      </el-form>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <el-col :span="24">
            <div class="basic-padding2">
              <el-button type="primary" @click="onSubmit">提交保存</el-button>
            </div>
          </el-col>
        </div>
        <div class="draft-area" v-show="draftHidden">
          <el-button type="primary" @click="draftLoad">加载草稿</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import {
  jmUploadFile,
  jmSchoolSearch,
  jmDictSelect,
  jmSchoolOrgSearch
} from '@/components/tool';
import * as dict from '@/dataset/qcrb';
import { delay } from '@/utils/utils.js';

export default {
  data() {
    return {
      crmId: null,
      formProlist: {
        deleteProfIds: [],
        baseinfo: {
          mail_list: []
        },
        schoolList: [],
      },
      schoolObj: {},
      addshPart: {},
      formMaster: {},
      activeNames: 0,
      formProcess: {},
      formTeach: {},
      hiddenIs: false,
      editableTabsValue: [],
      tabIndex: '',
      proHidden: false,
      professHidden: false,
      orgObj: {}, // 研究科,
      schoolId: 0,
      sortInt: 1,
      crmOfferId: {},
      loading: true,
      formDraft: {},
      draftHidden: false, // 草稿开关
      sNum1: false,
      sNum2: false,
      sNum3: false,
      sNum4: false,
    };
  },
  methods: {
    planUploadSuccess(response, file, fileList, index, sIndex) {
      console.info('response ==> ', response);
      if (response.result === -1) {
        this.$message.error(response.msg);
      }
      if (fileList.length > 0) {
        this.formProlist.schoolList[index].professorList[sIndex].plan_book_file = [];
        fileList.forEach((item) => {
          if (item.response && item.response.result && item.response.result === -1) {
            return false;
          }
          this.formProlist.schoolList[index].professorList[sIndex].plan_book_file.push({
            name: item.name,
            path: item.response ? item.response.data.path : item.path,
            status: item.status,
            uid: item.uid
          });
        });
      }
    },
    planUploadRemove(file, fileList, index, sIndex) {
      this.formProlist.schoolList[index].professorList[sIndex].plan_book_file = fileList;
    },
    planPreview(file) {
      window.open(this.$options.filters.imgHome(`/${file.path}`));
    },
    // 添加邮箱
    addMailList() {
      const emptyRow = {
        email: '',
        password: '',
        memo: ''
      };
      this.formProlist.baseinfo.mail_list.push(emptyRow);
    },
    // 删除邮箱
    deleteMailList (idx) {
      this.formProlist.baseinfo.mail_list.splice(idx, 1);
    },
    /**
     * 保存提交
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    onSubmit() {
      let student = JSON.stringify(this.formProlist);
      student = JSON.parse(student);
      student.schoolList.forEach((school) => {
        school.apply_type = school.apply_type.join(',');
        school.exam_type = school.exam_type.join(',');
      });
      student.prof_name2 = student.prof_name;
      this.$http._post({
        url: '/index/qc_process/saveSchoolList?type=apply',
        data: student,
      }).then(() => {
        this.$message.success('保存成功');
        this.getProcess();
      });
    },
    /**
     * 添加教授
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    tabadd(val) {
      let newTabName = this.formProlist.schoolList[val].professorList.length + 1;
      this.formProlist.schoolList[val].professorList.forEach((item) => {
        if (item.prof_name === `新教授${newTabName.toString()}`) {
          newTabName += 1;
        }
      });
      this.formProlist.schoolList[val].professorList.push({
        prof_name: `新教授${newTabName.toString()}`,
        prof_name2: `新教授${newTabName.toString()}`,
        prof_id: newTabName,
        id: 0,
        is_meet: '',
        status: '',
        plan_book_name: '',
        plan_book_file: [],
      });
      this.editableTabsValue[val] = `新教授${newTabName.toString()}`;
    },
    /**
     * 删除教授
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    tabremove(targetName, val) {
      let tabs = this.formProlist.schoolList[val].professorList;
      let activeName = this.editableTabsValue[val];
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.prof_name2 === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.prof_name2;
            }
          }
        });
      }
      tabs.forEach((tab) => {
        if (tab.prof_name2 === targetName) {
          this.formProlist.deleteProfIds.push(tab.id);
        }
      });
      this.editableTabsValue[val] = activeName;
      this.formProlist.schoolList[val].professorList =
        tabs.filter(tab => tab.prof_name2 !== targetName);
    },
    /**
     * 获取用户所有数据
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    getProcess() {
      if (!this.crmId) {
        return Promise.reject(new Error('无效的用户'));
      }
      return this.$http._get({
        url: `/index/qc_process/getSchoolList/crmid/${this.crmId}`
      }).then(({
        data
      }) => {
        this.loading = false;
        this.formProlist = data;
        if (this.formProlist.schoolList.length > 0) {
          this.proHidden = true;
        }
        this.formProlist.schoolList.forEach((school, index) => {
          if (index === 0) { // 默认展开选项卡
            this.activeNames = school.id;
          }
          school.apply_type = school.apply_type ?
            school.apply_type.split(',').map((item) => {
              return +item;
            }) : [];
          school.exam_type = school.exam_type ?
            school.exam_type.split(',').map((item) => {
              return +item;
            }) : [];
          if (school.professorList.length > 0) {
            this.editableTabsValue[index] = school.professorList[0].prof_name2;
            this.professHidden = true;
          }
        });
        this.crmOfferId = {
          crm_id: this.formProlist.crm_id,
          offer_id: this.formProlist.offer_id,
        };
        if (!this.formProlist.baseinfo.mail_list) {
          this.formProlist.baseinfo.mail_list = [{
            email: '',
            password: '',
            memo: ''
          }];
        }
      });
    },
    /**
     * 排序点击
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    sortClick() {
      this.formProlist.schoolList.sort((a, b) => {
        a = (new Date(a.expect_date || null)) * 1;
        b = (new Date(b.expect_date || null)) * 1;
        return this.sortInt > 0 ? (a - b) : (b - a);
      });
      this.sortInt = 0 - this.sortInt;
      this.formProlist.schoolList.forEach((school, index) => {
        this.editableTabsValue[index] = school.professorList[0].prof_name2;
      });
    },
    /**
     * 添加流程
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    addProcess() {
      if (this.schoolObj && this.schoolObj.sh_id && this.orgObj !== null) {
        let proLock = false;
        if (!this.orgObj.oid) {
          this.orgObj.oid = 0;
        }

        if (proLock === false) {
          this.formProlist.schoolList.push({
            id: 0,
            sh_id: this.schoolObj.sh_id,
            sh_name: this.schoolObj.sh_name_cn,
            org_id: this.orgObj.oid,
            org_name: this.orgObj.o_name_ww,
            expect_date: '',
            stage: 10,
            same_as_leaving: 0,
            confirm_date: '',
            apply_type: [],
            exam_type: [],
            professorList: [{
              prof_name: '新教授1',
              prof_name2: '新教授1',
              prof_id: 1,
              id: 0,
              is_meet: '',
              status: '',
              plan_book_name: '',
              plan_book_file: [],
            }]
          });
          let sl = (this.formProlist.schoolList.length - 1);
          this.editableTabsValue[sl] = '新教授1';
          this.proHidden = true;
        }
      } else if (this.orgObj === null) {
        this.$message.error('研究科不能为空');
      } else {
        this.$message.error('必须填写学校');
      }
    },
    /**
     * 第一封邮件时间赋值
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    timePush(val, index) {
      let date = new Date();
      let seperator1 = '-';
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = `0${strDate}`;
      }
      let currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate;
      if (val === 1) {
        if (index === 0) {
          if (this.formProlist.baseinfo.prof_list_date === '' || this.formProlist.baseinfo.prof_list_date === null) {
            this.formProlist.baseinfo.prof_list_date = currentdate;
          }
        }
        if (index === 1) {
          if (this.formProlist.baseinfo.prof_feedback_date === '' || this.formProlist.baseinfo.prof_feedback_date === null) {
            this.formProlist.baseinfo.prof_feedback_date = currentdate;
          }
        }
        if (index === 2) {
          if (this.formProlist.baseinfo.letter_complete_date === '' || this.formProlist.baseinfo.letter_complete_date === null) {
            this.formProlist.baseinfo.letter_complete_date = currentdate;
          }
        }
        if (index === 3) {
          if (this.formProlist.baseinfo.letter_send_date === '' || this.formProlist.baseinfo.letter_send_date === null) {
            this.formProlist.baseinfo.letter_send_date = currentdate;
          }
        }
      }
      if (val === 2) {
        if (index === 0) {
          this.formProlist.baseinfo.prof_list_date = '';
        }
        if (index === 1) {
          this.formProlist.baseinfo.prof_feedback_date = '';
        }
        if (index === 2) {
          this.formProlist.baseinfo.letter_complete_date = '';
        }
        if (index === 3) {
          this.formProlist.baseinfo.letter_send_date = '';
        }
      }
    },
    /**
     * 自动保存
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    autoSave() {
      delay(30000).then(() => {
        this.onDraftSubmit();
        this.autoSave();
      });
    },
    /**
     * 获取草稿
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    getDraft() {
      if (!this.crmId) {
        return false;
      }
      this.$http._get({
        url: `/index/qc_process/getDraft?type=apply&crmid=${this.crmId}`
      }).then((data) => {
        this.formDraft = data.data;
        if (this.formDraft !== '') {
          this.draftHidden = true;
        }
        this.formDraft.schoolList.forEach((school, index) => {
          school.apply_type = school.apply_type ?
            school.apply_type.split(',').map((item) => {
              return +item;
            }) : [];
          school.exam_type = school.exam_type ?
            school.exam_type.split(',').map((item) => {
              return +item;
            }) : [];
          if (school.professorList.length > 0) {
            this.editableTabsValue[index] = school.professorList[0].prof_name2;
            this.professHidden = true;
          }
        });
      });
    },
    /**
     * 自动草稿提交
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    onDraftSubmit() {
      let student = JSON.stringify(this.formProlist);
      student = JSON.parse(student);
      student.schoolList.forEach((school) => {
        school.apply_type = school.apply_type.join(',');
        school.exam_type = school.exam_type.join(',');
      });
      student.prof_name2 = student.prof_name;
      this.$http._post({
        url: '/index/qc_process/saveDraft?type=apply',
        data: student,
      }).then(() => {
        this.$message.success('已自动保存草稿');
      });
    },
    /**
     * 加载草稿
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    draftLoad() {
      this.formProlist = this.formDraft;
      this.draftHidden = false;
      this.$message.success('已加载草稿');
    },
    /**
     * 是否显示学校详情 ，优化加载，只有开启选项卡才render dom
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {Number} id [description]
     * @return {Boolean}    [description]
     */
    showSchoolDetail(id) {
      if (Array.isArray(this.activeNames)) {
        return this.activeNames.indexOf(id) > -1;
      }
      return this.activeNames === id;
    }
  },
  computed: {
    /**
     * 申请方式字典
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    cbApplyData() {
      return dict.cbApplyType;
    },
    /**
     * 考试方式字典
     *
     * 孙倡东 <sunchangdong@tuozhongedu.com>
     */
    cbApplyData2() {
      return dict.cbApplyType2;
    },
  },
  watch: {
    schoolObj(v) {
      if (v === null) {
        this.schoolId = 0;
      }
    },
    'schoolObj.sh_id' (val) {
      this.schoolId = val - 0;
    }
  },
  mounted() {
    this.crmId = this.$route.params.crmid;
    this.getProcess().then(() => {
      this.$nextTick(() => {
        if (this.$route.hash) {
          this.activeNames = this.$route.hash.replace('#s_', '') - 0;
        }
        delay(0).then(() => {
          this.getDraft();
          this.autoSave();
        });
        // 发送邮件下拉框禁用
        this.sNum1 = this.formProlist.baseinfo.is_prof_list === 1;
        this.sNum2 = this.formProlist.baseinfo.is_prof_feedback === 1;
        this.sNum3 = this.formProlist.baseinfo.is_letter_complete === 1;
        this.sNum4 = this.formProlist.baseinfo.is_letter_send === 1;
      });
    });
  },
  components: {
    'jm-crumbs': crumbs,
    jmUploadFile,
    jmSchoolSearch,
    jmSchoolOrgSearch,
    jmDictSelect
  }
};
</script>
<style scoped>
.basic-padding {
  display: block;
  clear: both;
  padding: 0 10px;
}

.basic-padding:after {
  display: block;
  content: "";
  clear: both;
}

.basic-padding2 {
  padding: 20px 10px;
  text-align: left;
}

.basic-padding2:after {
  display: block;
  content: "";
  clear: both;
}

.title-right {
  float: right;
  margin-right: 35px;
  height: 52px;
  overflow: hidden;
}

.wrap-line {
  padding: 20px 0;
  border-top: 1px solid #ddd;
  clear: both;
}
  .mails-wrap{
    background: #fff;
    border-radius: 10px;
    margin-bottom: 15px;
    padding: 15px;
  }
  .mails-line{
    margin-bottom: 10px;
  }
  .mails-line:last-of-type{
    margin-bottom: 0;
  }
  .mails-icon{
    font-size: 24px;
    color: #3368fa;
    line-height: 34px;
    cursor: pointer;
  }
</style>
<style>
.title-select {
  line-height: 22px;
  margin: 0 10px;
}
.qcrb-apply-title {
  background: none;
  pointer-events: none;
}

.qcrb-apply-title i {
  display: none;
}

.qcrb-applyAdmin .table-agile-info .el-tabs__nav-wrap {
  display: block;
  float: left;
}

.qcrb-applyAdmin .table-agile-info .el-tabs__nav-scroll {
  display: inline-block;
}

.qcrb-applyAdmin .table-agile-info .el-tabs__nav {
  display: inline-block;
}

.qcrb-applyAdmin .table-agile-info .el-tabs__new-tab {
  float: none;
  display: inline-block;
}
.qcrb-applyAdmin .table-agile-info .el-tabs__item{
  height: 42px;
  line-height: 42px;
  font-size: 16px;
}

.draft-area {
  position: fixed;
  bottom: 30px;
  left: 10px;
}
.disabled-select input{
  background: #a8a8a8;
  pointer-events: none;
  cursor: not-allowed;
}
.disabled-select i{
  display: none
}
.qcrb-applyAdmin .table-agile-info .el-collapse-item__header .el-collapse-item__arrow{
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.qcrb-applyAdmin .table-agile-info .el-collapse-item__header{
  display: block;
  position: relative;
}

</style>
